import { getAllBranchSubscription, getOverviewBranchSubscription } from './subscription';
import { getAllCustomer } from './customer';
import { getCustomers} from './customer';
import { getOverviewOrganization } from './organization';
import { getAppointments } from './appointment';
import { getOrganizations } from './organization';
import { getOverviewAppointment } from './appointment';
import { getBranches } from './branch';
import { getOverviewSale } from './sale';
import { getUsageOverview, getAllUsage } from './usage';
import {  getOverviewTransaction } from './transaction';
import { getEmployeeOverview } from './employee';
import { getOverviewCampaign } from './campaign';

export const agencyApis = {
    subscription: {
        getAllBranchSubscription,
        getOverviewBranchSubscription
    },
    organization: {
        getOverviewOrganization,
        getOrganizations
    },
    customer: {
        getAllCustomer,
        getCustomers
    },
    appointment: {
        getOverviewAppointment,
        getAppointments 
    },
    sale: {
        getOverviewSale
    },
    branch: {
        getBranches 
    },
    usage: {
        getAllUsage,
        getUsageOverview
    },
    transaction: {
        getOverviewTransaction
    },
    employee: {
        getEmployeeOverview
    },
    campaign: {
        getOverviewCampaign
    }
};